
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      players: null,
      formation: `4-4-2`,
    };
  },
  mounted () {
    this.$nextTick(() => {
      // Get the players of shared content
      if (this.$route.query?.d) {
        this.players = this.$route.query.d.split(`,`);
      }

      // Get formation
      if (this.$route.query?.f) {
        this.formation = this.$route.query.f;
      }
    });
  },
  methods: {
    closeModal () {
      this.$parent.shareClosed = true;
    },
  },
};
